import {
  humanReviewActionResponseSchema,
  humanReviewListResponseSchema,
  type HumanReview,
  type HumanReviewActionResponse,
  type HumanReviewListResponse,
  type HumanReviewStatus,
} from '@aica/api-types/schemas';
import { BaseApiClient } from '../base';
import { API_ENDPOINTS } from '../endpoints';

export type { HumanReview };

export class HumanReviewApi extends BaseApiClient {
  async list(params?: {
    status?: HumanReviewStatus | 'all';
    limit?: number;
    offset?: number;
  }): Promise<HumanReviewListResponse> {
    const query = this.buildQuery(params);
    return this.validatedRequest(
      `${API_ENDPOINTS.HUMAN_REVIEW}${query}`,
      humanReviewListResponseSchema
    );
  }

  async approve(
    id: string,
    notes: string,
    expectedDecisionVersion: number
  ): Promise<HumanReviewActionResponse> {
    return this.validatedRequest(
      API_ENDPOINTS.HUMAN_REVIEW_APPROVE(id),
      humanReviewActionResponseSchema,
      {
        method: 'POST',
        body: JSON.stringify({ notes, expectedDecisionVersion }),
      }
    );
  }

  async reject(
    id: string,
    notes: string,
    expectedDecisionVersion: number
  ): Promise<HumanReviewActionResponse> {
    return this.validatedRequest(
      API_ENDPOINTS.HUMAN_REVIEW_REJECT(id),
      humanReviewActionResponseSchema,
      {
        method: 'POST',
        body: JSON.stringify({ notes, expectedDecisionVersion }),
      }
    );
  }

  async retry(
    id: string,
    expectedDecisionVersion: number
  ): Promise<HumanReviewActionResponse> {
    return this.validatedRequest(
      API_ENDPOINTS.HUMAN_REVIEW_RETRY(id),
      humanReviewActionResponseSchema,
      {
        method: 'POST',
        body: JSON.stringify({ expectedDecisionVersion }),
      }
    );
  }
}
